import { dependencies } from '@pn/core/dependencies';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { isNil } from 'lodash-es';
import { intelUiSlice } from './intelUiSlice';
import type { IIntelUIActions, IIntelUIStorage } from './ports';

export const useReduxIntelUIStorage = (): IIntelUIStorage => {
  const { name, getInitialState } = intelUiSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isMapHidden: useSliceSelector((state) => state.isMapHidden),
    isLegendHidden: useSliceSelector((state) => state.isLegendHidden),
    enableIndividualMapSelections: useSliceSelector(
      (state) => state.enableIndividualMapSelections
    ),
    preferredAreaUnits: useSliceSelector((state) => state.preferredAreaUnits),
    tableDensity: useSliceSelector((state) => state.tableDensity),
  };
};

export const reduxIntelUIActions = (): IIntelUIActions => {
  const { dispatch, getState } = dependencies.store;
  const { actions, name } = intelUiSlice;

  if (isNil(getState()[name])) {
    throw new Error(`[${name}] reducer has not been injected yet`);
  }

  return {
    show: () => dispatch(actions.show()),
    hide: () => dispatch(actions.hide()),
    toggleMap: () => dispatch(actions.toggleMap()),
    toggleLegend: () => dispatch(actions.toggleLegend()),
    setPreferredAreaUnits: (unit) =>
      dispatch(actions.setPreferredAreaUnits(unit)),
    changeTableDensity: (density) =>
      dispatch(actions.changeTableDensity(density)),
    toggleIndividualMapSelections: () =>
      dispatch(actions.toggleIndividualMapSelections()),
  };
};
